import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Every "Book Now" / "AI Quote" opener now goes to the dedicated service pages (one photo → AI quote per service)
const QuoteWizard = ({ open, onClose, to = "/services" }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!open) return;
    onClose?.();
    navigate(to);
  }, [open, onClose, navigate, to]);
  return null;
};

export default QuoteWizard;
